module.exports = __webpack_public_path__ + "img/matthias.b2af5260.png";